import * as React from 'react';
import { LogoCentered } from 'src/app/Partials';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ResetPasswordSucceeded.messages';
import { Link } from 'react-router-dom';

export interface ResetPasswordSucceededPageProps {
  dispatch: any;
  resetPassword: RequestApiResult<any>;
}

export class ResetPasswordSucceededPageComponent extends React.Component<ResetPasswordSucceededPageProps> {
  
  componentWillUnmount() {
    this.props.dispatch(requestAPIActions.loadCleared('resetPasswordChange'));
  }

  public render() {
    const { resetPassword } = this.props;
    return (
      <div className="page-resetpassword d-flex justify-content-center align-items-center h-100">
        <div className="inner w-100 pt-5 pb-5">
          <div className="row m-0 mb-4">
            <div className="col-12">
              <LogoCentered />
            </div>
          </div>
          <h4>
            <FormattedMessage {...MESSAGES.resetPassword} />
          </h4>
          <p className="mb-4">
            <FormattedMessage {...MESSAGES.resetPasswordSucceeded} />
          </p>
          <Link className="btn btn-secondary w-100 d-block" to="/">
            <FormattedMessage {...MESSAGES.resetPasswordButton} />
          </Link>
        </div>
        {resetPassword && !resetPassword.result && (
          <Redirect to="/" />
        )}
      </div>
    );
  }
}


interface StateProps {
  resetPassword: RequestApiResult<any>;
} 

export const ResetPasswordSucceededPage = connect((state: StateProps) => ({
  resetPassword: state.resetPassword,
}))( ResetPasswordSucceededPageComponent);

export default ResetPasswordSucceededPage;